import Shape from './../components/Shape';

const drawScaleScorePath = (x, y, onePartSize, rotation, ir, mr, rings, scaleScores) => {
    const path = Shape.create()
        .fillColor('transparent')
        .strokeColor('rgba(100, 100, 100, .7)')
        .strokeThickness('3px');
    let selector = 0;
    for (let angle = 0; angle < Math.PI * 2; angle += onePartSize) {
        const ringWidth = ir + (mr / rings);
        const a = angle + rotation + (onePartSize / 2);
        // divide the positioning of the dot by 1.5 so it appears in the middle of the ring
        const r = (ringWidth * (scaleScores[selector]) / 1.5);
        if (angle === 0) {
            path.moveTo(x + Math.sin(a) * r, y + Math.cos(a) * r);
        } else {
            path.lineTo(x + Math.sin(a) * r, y + Math.cos(a) * r);
        }
        selector++;
    }
    return path.close().element();
};

export default drawScaleScorePath;
